import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { FormGroupControl } from '@components/Base';

const GROUP_PROPS = { className: 'mb-3' };

const ClaimCardBody = () => {
  const { t } = useTranslation();

  return (
    <Card.Body>
      <Card.Title>{t('common:claim')}</Card.Title>

      <Row>
        <Col>
          <FormGroupControl
            name="passengersAndThirdPartiesPoliceReports"
            type="file"
            label={t('carInsuranceClaimForm.passengersAndThirdPartiesPoliceReports.label')}
            required
            multiple
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <FormGroupControl
            name="supportingDocuments"
            type="file"
            multiple
            label={t('carInsuranceClaimForm.supportingDocuments.label')}
            required
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <FormGroupControl
            name="totalClaimedAmount"
            label={t('claimForm.totalClaimedAmount.label')}
            required
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
    </Card.Body>
  );
};

export { ClaimCardBody };
